const DEFAULT_CONFIG = { precision: 2 , pattern: `! #`, negativePattern: '- ! #'};
const EURO_DEFAULT_CONFIG = { precision: 2, decimal: ',', separator: '.', pattern: `# !`, negativePattern: '- # !'};

const CURRENCY_TYPE_CONFIG = Object.freeze({
  'EUR': EURO_DEFAULT_CONFIG,
  '€': EURO_DEFAULT_CONFIG,
});

const getConfigOf = (currencyType) => {
  return CURRENCY_TYPE_CONFIG[currencyType] ?? DEFAULT_CONFIG;
}

export { CURRENCY_TYPE_CONFIG, getConfigOf };
